const jobNum = [{
  desc: '工号查询',
  options: {
    url: '/jobNo/getJobNoList',
    method: 'post'
  },
  vuex: false
}, {
  desc: '修改工号信息接口',
  options: {
    url: '/jobNo/updateJobNo',
    method: 'post'
  }
}, {
  desc: '查询常用工号接口',
  options: {
    url: '/jobNo/getCommonlyJobNos',
    method: 'post',
    argsParams: false
  }
}, {
  desc: '批量组织机构授权和取消授权接口',
  options: {
    url: '/jobNo/batchUpdateJobNo',
    method: 'post',
    argsParams: false
  }
}, {
  desc: '设置常用工号',
  options: {
    url: '/jobNo/saveCustomerSetting',
    method: 'post',
    argsParams: false
  }
}, {
  desc: '获取筛选条件的保险公司信息',
  options: {
    url: '/jobNo/getSmallSuppliers',
    method: 'post'
  },
  vuex: true
}, {
  desc: '新增、修改工号信息接口',
  options: {
    url: '/jobNo/addOrUpdateJobNo',
    method: 'post'
  }
}, {
  desc: '获取工号信息',
  options: {
    url: '/jobNo/getSmallJobNoList',
    method: 'post',
    formdata: true // 是否通过formdata的方式传参
  }
}, {
  desc: '批量修改工号状态',
  options: {
    url: '/jobNo/updateJobNoStatusByIds',
    method: 'post'
  }
}, {
  desc: '工号登录',
  options: {
    url: '/vehicle/rpa/login',
    method: 'post',
    baseURL: '/insapi/v3/insured'
  }
}, {
  desc: '下载报价配置',
  options: {
    url: '/priceConfig/exportPriceConfig',
    method: 'post',
    baseURL: '/insapi/v3/insured/base',
    responseType: 'arraybuffer'
  }
}, {
  desc: '置顶工号',
  options: {
    url: '/base/config/signTopPriceConfig',
    method: 'post',
    baseURL: '/insapi/v3/insured'
  }
}, {
  desc: '融合工号',
  options: {
    url: '/base/jobno/relationOrUpdataJobNo',
    method: 'post',
    baseURL: '/insapi/v3/insured'
  }
}, {
  desc: '查询工号',
  options: {
    url: '/base/jobno/queryRelationJobNo',
    method: 'post',
    baseURL: '/insapi/v3/insured'
  }
}, {
  desc: '新增修改授权工号',
  options: {
    url: '/base/riskControl/addOrUpdatePriceJobNoRiskControl',
    method: 'post',
    baseURL: '/insapi/v3/insured'
  }
}, {
  desc: '查询授权工号',
  options: {
    url: '/base/riskControl/queryPriceJobNoRiskControl',
    method: 'post',
    baseURL: '/insapi/v3/insured'
  }
}, {
  desc: '查询不需要保单号的保司',
  options: {
    url: '/priceConfig/queryIsPolicyIds',
    method: 'get',
    baseURL: '/insapi/v3/insured/base'
  }
}, {
  desc: '工号日志查看',
  options: {
    url: '/jobNo/queryPartnerJobLog',
    method: 'post'
  }
}, {
  desc: '获取工号来源下拉列表',
  options: {
    url: '/partner/queryPartnerRelation',
    method: 'post',
    baseURL: '/insapi/v3/insured/base'
  }
}]
export default jobNum



// WEBPACK FOOTER //
// ./src/api/jobnum.js